import React, { useState } from "react";
import Modal, { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ModalInfo = styled.div`
  text-align: left;
  font-size: 12px;
  color: #1070b6;
  font-weight: bold;
`;

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

interface ConfirmExtraCreditPaymentModalProps {
  visible: boolean;
  creditAmount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmExtraCreditPaymentModal = (
  props: ConfirmExtraCreditPaymentModalProps
) => {
  const { t } = useTranslation("my_credits");

  const { onConfirm, onCancel, creditAmount } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Modal title={t("CONFIRM PAYMENT")} {...props} maskClosable={!loading}>
      <ModalText>
        {t("I want to buy an additional {{ amount }} credit", {
          amount: creditAmount,
          count: creditAmount,
        })}
      </ModalText>
      <ModalInfo>
        {t("Credits are valid for 28 days")}.{" "}
        {t(
          "This can take a little while. Please do not close or refresh this page while your request is being processed."
        )}
      </ModalInfo>

      <br />

      <ModalButton loading={loading} onClick={() => handleConfirm()}>
        {t("YES, I DO")}
      </ModalButton>
      <ModalButton disabled={loading} onClick={() => onCancel()}>
        {t("NO, CANCEL IT")}
      </ModalButton>
    </Modal>
  );
};

export default ConfirmExtraCreditPaymentModal;
